import lawsuitFollowAllot from "./lawsuit-follow-allot.vue";
import LawsuitFollowArbitrate from "./lawsuit-follow-arbitrate.vue";
import LawsuitFollowEvaluate from "./lawsuit-follow-evaluate.vue";
import LawsuitFollowExecute from "./lawsuit-follow-execute.vue";
import LawsuitFollowExecuted from "./lawsuit-follow-executed.vue";
import LawsuitFollowForce from "./lawsuit-follow-force.vue";
import LawsuitFollowRegister from "./lawsuit-follow-register.vue";
import LawsuitFollowTrial from "./lawsuit-follow-trial.vue";
var LawsuitFollowKind = {
    lawsuitFollowAllot: lawsuitFollowAllot,
    LawsuitFollowArbitrate: LawsuitFollowArbitrate,
    LawsuitFollowEvaluate: LawsuitFollowEvaluate,
    LawsuitFollowExecute: LawsuitFollowExecute,
    LawsuitFollowExecuted: LawsuitFollowExecuted,
    LawsuitFollowForce: LawsuitFollowForce,
    LawsuitFollowRegister: LawsuitFollowRegister,
    LawsuitFollowTrial: LawsuitFollowTrial
};
export default LawsuitFollowKind;
